import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
  description: "",
  category: "",
  whyChooseUs: "",
  weight: "",
  dimensions: "",
  price: 0,
  hasDiscount: false,
  discountPrice: 0,
  hasSize: false,
  hasColor: false,
  variants: [],
  availableStock: 0,
  productURL: "",
  images: [],
  uploadProgress: 0,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    // Set a single field value
    setField: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },

    // Toggle a boolean field
    toggleField: (state, action) => {
      const { field } = action.payload;
      state[field] = !state[field];
    },

    // Add a new variant
    addVariant: (state) => {
      state.variants.push({ size: "", color: "", stock: 0 });
    },

    // Update a specific variant
    updateVariant: (state, action) => {
      const { index, field, value } = action.payload;
      if (state.variants[index]) {
        state.variants[index][field] = value;
      }
    },

    // Remove a variant
    removeVariant: (state, action) => {
      const { index } = action.payload;
      state.variants.splice(index, 1);
    },

    
    uploadProductImages: (state, action) => {
      const newImages = action.payload; // Array of { name, preview }
      state.images = [...state.images, ...newImages];
    },

    // Remove a specific product image
    removeProductImage: (state, action) => {
      const index = action.payload;
      state.images.splice(index, 1);
    },

    // Set upload progress
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },

    // Reset the product to the initial state
    resetProduct: () => initialState,
  },
});

export const {
  setField,
  toggleField,
  addVariant,
  updateVariant,
  removeVariant,
  uploadProductImages,
  removeProductImage,
  setUploadProgress,
  resetProduct,
} = productSlice.actions;

export default productSlice.reducer;
